module.exports = __webpack_public_path__ + "img/nithra_loading.0bac0e40.gif";